import ZABB from "./ZABB";
import ZHB from "./ZHB";
import ZXBW from "./ZXBW";
import ZZJS from "./ZZJS";
import HRYH from "./HRYH";

export default {
    ZABB,
    ZHB,
    ZXBW,
    ZZJS,
    HRYH,
};
